<template>
	<b-button
			@click="() => { modalState = true }"
			size="sm"
			block
			:disabled="buttonDisabled"
			:variant="(httpRequestInProgress) ? 'success': 'primary'"
	><!-- button -->
		<span v-if="httpRequestInProgress">
			<b-spinner
				type="grow"
				label="Loading..."
				small
			/>
			</span>
		<span v-else>Händlerstorno</span>
		<b-modal
			v-model="modalState"
			id="modal-vendor-cancellation"
			title="Händlerstorno"
			@ok="submit()"
			cancel-title="abbrechen"
			size="md"
		><!-- modal -->
			Händler: <strong>{{ customerOrder.customerorderitems[0].stock.vendorName }}</strong><br>
			Artikel: <strong>{{ customerOrder.customerorderitems[0].stock.material.name }}</strong><br>
			<div class="d-flex">
				Menge:
				<b-form-input
						style="max-width: 100px;"
						class="ml-2"
						v-model="selectedQuantity"
						type="number"
						:min="1"
						:max="this.customerOrder.customerorderitems[0].quantity"
						size="sm">
				</b-form-input>
			</div>

			Sie sie sicher, dass sie diesen Artikel stornieren möchten?<br>
		</b-modal>
		<modal-error-component v-model="errorModal"></modal-error-component>
	</b-button>
</template>
<script>
import ModalErrorComponent from "../ModalErrorComponent.vue";

export default {
	components: {ModalErrorComponent},
	props: ['customerOrder'],
	data() {
		return {
			modalState: false,
			httpRequestInProgress: false,
			selectedQuantity: 1,
			errorModal: {
				show: false,
				message: '',
				error: null,
				title: 'Fehler beim Erstellen der Stornierung',
			}
		}
	},
	computed: {
		buttonDisabled: function () {
			return this.httpRequestInProgress
		}
	},
	methods: {
		submit() {
			if(this.customerOrder.maybeInboundShipmentDate && this.customerOrder.orderState == 0) return;
			this.httpRequestInProgress = true;
			const payload = {
				quantity: this.selectedQuantity,
				customerOrderId: this.customerOrder.id,
				stockId: this.customerOrder.customerorderitems[0].stock.id
			};
				axios.post('/customerorder/action/vendorcancellation', payload)
				.then((response) => {
				this.$emit("success");
				this.httpRequestInProgress = false;
				this.modalState = false;
				//success toast
				this.$bvToast.toast('Die Stornierung wurde erfolgreich erstellt.', {
					title: 'Stornierung erstellt',
					variant: 'success',
					solid: true
				});
			}).catch(error => {
				console.error(error);
					this.errorModal = {
						show: true,
						error: error,
						title: 'Fehler beim Erstellen der Stornierung',
					};
				this.httpRequestInProgress = false;
			});
		}
	}
}
</script>
